module.exports = __webpack_public_path__ + "img/5C5743_262418_393727_342C20-256px.d8f853e0.png";